<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="mb-4" style="z-index:0 !important;">
    <div slot="no-body" class="tabs-container px-6 pt-2">
      <vs-tabs v-model="activeTab">
        <vs-tab label="My Info">
          <div class="tab-text">
            <student-information class="mt-4" />
          </div>
        </vs-tab>
        <vs-tab label="My Documents">
          <div class="tab-text">
            <student-docs class="mt-4" />
          </div>
        </vs-tab>
        <vs-tab label="My Courses">
          <div class="tab-text">
            <student-courses class="mt-4" />
          </div>
        </vs-tab>
        <vs-tab label="My Transactions">
          <div class="tab-text">
            <student-transactions class="mt-4" />
          </div>
        </vs-tab>
        <vs-tab label="Profile Links">
          <div class="tab-text">
            <student-profile-links/>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import StudentDocs from "./StudentDocs.vue";
import StudentInformation from "./StudentInformation.vue";
import StudentCourses from "./StudentCourses.vue";
import StudentTransactions from "./StudentTransactions.vue";
import StudentProfileLinks from "../../components/studentdashboard/StudentProfileLinks.vue"

export default {
  components: {
    StudentDocs,
    StudentInformation,
    StudentCourses,
    StudentTransactions,
    StudentProfileLinks
  },
  data() {
    return {
      activeTab: 0
    };
  },
  watch: {
    activeTab() {}
  },
  methods: {},
  mounted() {
    
  },
  created() {
    var self = this;
    document.title = "DigiCampus";
    this.$store.dispatch("updateTheme", "dark");
    if (self.$route.params.CourseProgress) {
      self.activeTab = 2;
    }

    if (self.$route.query.studentDocumentId) {
      self.activeTab = 1;
    }
  },
};
</script>
<style lang='scss'>
.tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}

.vs-tabs-primary .con-ul-tabs .activeChild button, .vs-tabs-primary .con-ul-tabs button:not(:disabled):hover {
  color: rgba(var(--vs-fontcolor),1)!important;
}
</style>
